import { render, staticRenderFns } from "./reviewContent.vue?vue&type=template&id=039a0dba&scoped=true&"
import script from "./reviewContent.vue?vue&type=script&lang=js&"
export * from "./reviewContent.vue?vue&type=script&lang=js&"
import style0 from "./reviewContent.vue?vue&type=style&index=0&id=039a0dba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039a0dba",
  null
  
)

export default component.exports